<template>
    <Text v-bind="attrs" class="break-words whitespace-pre-wrap" :class="{ noScroll: 'overflow-y-scroll' }"
        ><slot
    /></Text>
</template>

<script setup>
import { useAttrs } from 'vue'
import Text from '@/components/Text.vue'

const props = defineProps({
    noScroll: { type: Boolean, default: false },
})

// Accessing undeclared attributes
const attrs = useAttrs()

// Set inheritAttrs to false to prevent attributes being automatically added to the root element
defineOptions({
    inheritAttrs: false,
})
</script>
